declare var ym: any;
declare var __GetI: any;

export function ymEvent(target: string) {
  if (typeof ym !== "undefined") {
    ym(95530516, 'reachGoal', target);
  }
}

export function giEvent(target: string) {
  if (typeof __GetI !== "undefined") {
    const p = {
      type: "CONVERSION",
      /* config START */
      site_id: "9176",
      order:[],
      transaction_id: "",
      revenue: "",
      pixel_id: target
      /* config END */
    };
    __GetI.push(p);
  }
}